// @ts-check

/** Reasons offered whenever stock is adjusted by hand, as [value, label]. Shared by the single and bulk dialogs. */
export const STOCK_ADJUST_REASONS = [
  ['Restock', 'Restock'],
  ['Return', 'Customer Return'],
  ['Damage', 'Damage / Defective'],
  ['Loss', 'Loss / Shrinkage'],
  ['Correction', 'Inventory Correction'],
  ['Sample Pulled', 'Sample Pulled (Marketing)'],
  ['Sample Returned', 'Sample Returned'],
  ['Other', 'Other'],
];
